<template>
  <custom-actions show-back>
    <el-form class="mt30 form" :model="formData" :rules="rules" ref="form" label-width="140px">
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="formData.roleName" placeholder="请输入角色名称" />
      </el-form-item>
      <el-form-item label="角色描述" prop="description">
        <el-input type="textarea" v-model="formData.description" placeholder="请输入角色描述" />
      </el-form-item>
      <el-form-item label="排序号" prop="orderNum">
        <el-input v-model="formData.orderNum" placeholder="请输入排序号" />
      </el-form-item>
      <el-form-item label="数据权限">
        <el-radio-group v-model="formData.dataPermission">
          <el-radio label="1">所有数据</el-radio>
          <el-radio label="2">本人油罐数据</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="菜单">
        <div class="items">
          <div class="item">
            <div class="header">菜单权限</div>
            <div class="content">
              <el-tree
                ref="menuTree"
                node-key="menuId"
                :default-checked-keys="checkedKeys"
                :check-strictly="false"
                default-expand-all
                show-checkbox
                :data="menus"
                :props="{ label: 'menuName', children: 'childNode' }"
                @node-click="onMenuClick"
                @check="handleTreeCheck"
              >
                <template v-slot="{ data }">
                  <div class="org-item">
                    <span>{{ data.menuName }}</span>
                    <i class="el-icon-lollipop" :class="{ visible: data.button && data.button.length }"></i>
                  </div>
                </template>
              </el-tree>
            </div>
          </div>
          <div class="item">
            <div class="header">按钮权限</div>
            <div class="content">
              <el-checkbox
                v-if="buttonList && buttonList.length"
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
              >全选</el-checkbox>
              <div class="mt15"></div>
              <el-checkbox @change="handlecheckedPermissionChange" v-model="item.isSelect"
                v-for="(item, index) in buttonList" :label="item.butCode" :key="index">{{ item.butName }}</el-checkbox>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit" class="global-button">保存</el-button>
      </el-form-item>
    </el-form>
  </custom-actions>
</template>

<script>
import CustomActions from '../../components/CustomActions.vue'
export default {
  components: { CustomActions },
  name: 'RoleAdd',
  data () {
    return {
      menus: [],
      formData: {
        roleName: null,
        description: null,
        orderNum: null,
        dataPermission: '2',
        menuList: []
      },
      rules: {
        roleName: [{ required: true, message: '请输入角色名称', trigger: 'blur' }]
      },
      checkAll: false,
      isIndeterminate: false,
      buttonList: [],
      checkedKeys: [],
      // 记录当前选中的菜单节点
      currentMenuNode: null
    }
  },
  computed: {
    roleId () {
      return this.$route.query.roleId
    }
  },
  created () {
    this.loadMenuByRoleId()
    if (this.roleId) {
      this.loadDetail()
    }
  },
  methods: {
    loadDetail () {
      this.$axios.get(this.$apis.system.selectSysRoleByRoleId, {
        params: { roleId: this.roleId }
      }).then(res => {
        this.formData = res
      })
    },
    loadMenuByRoleId () {
      this.$axios.get(this.$apis.system.selectSysMenuById, {
        params: {
          roleId: this.roleId
        }
      }).then(res => {
        this.menus = res.webMenu
        this.checkedKeys = []
        this.checkedKeysSet(res.webMenu)
      })
    },
    // 仅收集已授权的叶子菜单；父节点交给树组件计算全选或半选，避免默认勾选父节点时误选全部兄弟菜单
    checkedKeysSet (menus) {
      menus.forEach((item) => {
        if (item.childNode && item.childNode.length) {
          this.checkedKeysSet(item.childNode)
        } else if (item.isSelect === '1') {
          this.checkedKeys.push(item.menuId)
        }
      })
    },
    // 递归同步节点以及所有子节点的button.isSelect状态
    syncNodeButtonStatus(node, checked) {
      // 当前节点按钮同步
      if (node.button && node.button.length) {
        node.button.forEach(btn => {
          btn.isSelect = checked
        })
      }
      // 如果存在子节点，递归处理子节点
      if (node.childNode && node.childNode.length) {
        node.childNode.forEach(child => {
          this.syncNodeButtonStatus(child, checked)
        })
      }
    },
    // 点击菜单文字，切换右侧按钮列表展示，不修改按钮勾选状态
    onMenuClick (data) {
      this.currentMenuNode = data
      this.buttonList = data.button || []
      this.refreshButtonCheckStatus()
    },
    // 菜单复选框勾选/取消事件
    handleTreeCheck (data, checkedInfo) {
      console.log('handleTreeCheck', data, checkedInfo)
      // 判断当前菜单是否勾选
      const isChecked = checkedInfo.checkedNodes.some(node => node.menuId === data.menuId)
      // 递归：当前节点 + 所有子节点按钮全部同步选中状态
      this.syncNodeButtonStatus(data, isChecked)

      this.currentMenuNode = data
      this.buttonList = data.button || []

      this.refreshButtonCheckStatus()
    },
    // 更新全选、半选状态
    refreshButtonCheckStatus () {
      if (!this.buttonList.length) {
        this.checkAll = false
        this.isIndeterminate = false
        return
      }
      this.checkAll = this.buttonList.every(item => item.isSelect)
      const checkedCount = this.buttonList.filter(item => item.isSelect).length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.buttonList.length
    },
    // 按钮全选切换
    handleCheckAllChange (val) {
      this.buttonList.forEach(item => {
        item.isSelect = val
      })
      this.isIndeterminate = false
    },
    // 单个按钮勾选变化
    handlecheckedPermissionChange () {
      this.refreshButtonCheckStatus()
    },
    submit () {
      const nodes = this.$refs.menuTree.getCheckedNodes(false, true)
      this.formData.menuList = nodes.map(node => {
        const button = node.button || []
        return {
          menuId: node.menuId,
          button: button.filter(item => item.isSelect).map(item => {
            return { butCode: item.butCode }
          })
        }
      })
      this.$refs.form.validate(valid => {
        if (valid) {
          const url = this.roleId ? this.$apis.system.updateSysRole : this.$apis.system.insertSysRole
          this.$axios.post(url, this.formData).then(() => {
            this.$router.back()
          })
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.form {
  width: 600px;
}

.org-item {
  display: flex;
  align-items: center;

  i {
    font-size: 14px;
    margin-left: 3px;
    visibility: hidden;

    &.visible {
      visibility: visible;
    }
  }

  span {
    line-height: 15px;
    font-size: 13px;
    text-decoration: underline;
  }
}

.items {
  display: flex;
  width: 100%;

  .item {
    flex: 1;
    border: 1px solid #eee;

    &:nth-child(2) {
      margin-left: 10px;
    }

    .header {
      background-color: #eee;
      margin-bottom: 10px;
      padding: 3px 10px;
      margin-top: -1px;
    }

    .content {
      padding-left: 10px;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
